import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
import { Icon } from '@iconify/react';
// material
import { TextField, Select, Stack, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import closeFill from '@iconify/icons-eva/close-fill';

import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { useUpdateProfileMutation } from '../../../redux/slices/api';
import useAuth from '../../../hooks/useAuth';
import { MIconButton } from '../../@material-extend';
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

export default function UserAfterRegistrationForm() {
  const nav = useNavigate();
  const { user, updateUser } = useAuth();
  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [role, setRole] = useState('architect');
  const [updateProfile, { isLoading: isLoadingUpdate }] = useUpdateProfileMutation();

  const [roles, setRoles] = useState(['architect', 'manufacturer']);

  const handleChangeRole = (event) => {
    setRole(event.target.value);
  };

  const UserSchema = Yup.object().shape({
    firstName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('First name required'),
    lastName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Last name required'),
    // role: Yup.string()
  });

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      // role: 'architect'
    },
    validationSchema: UserSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      try {
        if (user.emailVerified) {
          const data = {
            id: user.id,
            payload: { 
              // role: values.role, 
              display_name: `${values.firstName} ${values.lastName}` 
            }
          };
          await updateProfile(data);
          await updateUser();
          enqueueSnackbar('Saved', {
            variant: 'success',
            action: (key) => (
              <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                <Icon icon={closeFill} />
              </MIconButton>
            )
          });
          if (isMountedRef.current) {
            setSubmitting(false);
          }
          nav(PATH_DASHBOARD.yawn.root);
        } else {
          enqueueSnackbar('Please verify your email first', {
            variant: 'error',
            action: (key) => (
              <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                <Icon icon={closeFill} />
              </MIconButton>
            )
          });
        }
      } catch (error) {
        console.error(error);
        if (isMountedRef.current) {
          setErrors({ afterSubmit: error.message });
          setSubmitting(false);
        }
      }
    }
  });

  const { values, errors, isValid, touched, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          {errors.afterSubmit && <Alert severity="error">{errors.afterSubmit}</Alert>}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              fullWidth
              label="First name"
              {...getFieldProps('firstName')}
              error={Boolean(touched.firstName && errors.firstName)}
              helperText={touched.firstName && errors.firstName}
            />

            <TextField
              fullWidth
              label="Last name"
              {...getFieldProps('lastName')}
              error={Boolean(touched.lastName && errors.lastName)}
              helperText={touched.lastName && errors.lastName}
            />
          </Stack>
          {/* <Select native value={role} onChange={handleChangeRole} {...getFieldProps('role')}>
            {roles.map((role, index) => (
              <option key={index} value={role}>
                {role.charAt(0).toUpperCase() + role.slice(1)}
              </option>
            ))}
          </Select> */}
          <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
            Update Profile
          </LoadingButton>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
